import { useCallback, useEffect } from 'react';
import { fabric } from 'fabric';
import { FabricObjectWithSrc, sortImagesAscFunction } from '../../../../shared/Helpers';

function useSetImages(canvasEl: Nullable<fabric.Canvas>, fabricImages: FabricObjectWithSrc[], onImagesLoaded: Function) {
  const setImages = useCallback(
    (fabricJsImages: FabricObjectWithSrc[]) => {
      if (!canvasEl) return;

      if (fabricJsImages.length === 0) {
        onImagesLoaded();
        return;
      }

      canvasEl.clear();
      // canvasEl.selection = false;
      // canvasEl.defaultCursor = 'grab';

      let imagesCount = 0;
      fabricJsImages.forEach(fabricJsImage => {
        var img = new Image();
        img.src = fabricJsImage.src;
        img.onload = event => {
          var fabricImage = new fabric.Image(img, fabricJsImage);
          fabricImage.setControlsVisibility({
            mt: false,
            mb: false,
            ml: false,
            mr: false
          });
          canvasEl!.add(fabricImage);

          imagesCount++;

          if (imagesCount === fabricJsImages.length) {
            // sort
            const objects = canvasEl.getObjects();

            const sortedImages = [...fabricJsImages].sort(sortImagesAscFunction);
            sortedImages.forEach(image => {
              let object = objects.find(x => x.data.name === image.name);
              if (object) canvasEl!.bringToFront(object);
            });

            onImagesLoaded();

            (canvasEl as any).uniformScaling = true;
          }
        };
      });
    },
    [canvasEl, onImagesLoaded]
  );

  useEffect(() => {
    if (canvasEl) {
      setImages(fabricImages);
    }
  }, [canvasEl, fabricImages, setImages]);
}

export default useSetImages;
